export default "__VITE_ASSET__DlSAbxh3__"